import { ReactElement } from 'react';
import { formatValue } from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/utils';

import ReportTableCell from '@/pages/Reports/DynamicReport/components/ReportTable/ReportTableCell';
import Table from '@/common/Table';
import { TrainingReportCity } from '@/features/PdfLayout/layouts/TrainingReport/utils';

export type TrainingReportPdfCityRowProps = {
  city: TrainingReportCity;
  keys: string[];
};

const TrainingReportPdfCityRow = ({ city, keys }: TrainingReportPdfCityRowProps): ReactElement => (
  // Rows must not virtualize: the headless PDF render would print off-screen rows blank
  <Table.Row className="TrainingReportPdf-CityRow" virtualize={false}>
    {keys.map((key) => (
      <ReportTableCell className={key.toUpperCase()} key={key}>
        {formatValue(city.values[key])}
      </ReportTableCell>
    ))}
  </Table.Row>
);

export default TrainingReportPdfCityRow;
